import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import order from '@/components/order'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
      
    },
    {
      path: '/order',
      name: 'order',
      component: order,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js